const sidebarConnection = document.querySelector(".js-sidebar-connection");

if (sidebarConnection) {
    const sidebarConnectionOpen = sidebarConnection.querySelector(".js-sidebar-connection-open");
    const sidebarConnectionClose = sidebarConnection.querySelector(".js-sidebar-connection-close");
    if (sidebarConnectionOpen && sidebarConnectionClose) {
        const buttons = [sidebarConnectionOpen, sidebarConnectionClose];

        for (const button of buttons) {
            button.addEventListener("click", () => {
                toggleModal();
            });
        }
    }
}

function toggleModal() {
    if (!sidebarConnection.classList.contains("active")) {
        openModal();
    } else {
        closeModal();
    }
}

function openModal() {
    sidebarConnection.classList.add("active");
}
function closeModal() {
    if (sidebarConnection.classList.contains("active")) {
        sidebarConnection.classList.remove("active");
    }
}
